exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
exports.push([module.id, ".item {\n  padding: 2px 0 2px 40px;\n  position: relative;\n  transition: background-color 0.2s ease;\n}\n.item p {\n  margin: 2px 0;\n}\n.item .title:visited {\n  color: #828282;\n}\n.item .index {\n  color: #828282;\n  position: absolute;\n  width: 30px;\n  text-align: right;\n  left: 0;\n  top: 4px;\n}\n.item .domain,\n.item .subtext {\n  font-size: 11px;\n  color: #828282;\n}\n.item .domain a,\n.item .subtext a {\n  color: #828282;\n}\n.item .subtext a:hover {\n  text-decoration: underline;\n}\n", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/stylus-loader!../vue-loader/lib/selector.js?style/stylus!./src/components/item.vue
 ** module id = 88
 ** module chunks = 0
 **/